// @ts-nocheck
import { useState, useMemo, useRef, useContext } from "react";
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  chakra,
  Text,
  Flex,
  IconButton,
  Button,
  Center,
  useColorModeValue,
  Tooltip,
  Image,
} from "@chakra-ui/react";
import { TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";
import { useTable, useSortBy } from "react-table";
import moment from "moment";
import { FaRobot } from "react-icons/fa";
import { AiOutlineEye } from "react-icons/ai";
import toast from "react-hot-toast";
import { useSession } from "next-auth/react";
import PuffLoader from "react-spinners/PuffLoader";
import Tweet from "components/tweets/masonry/tweet";
import * as analytics from "utils/analytics";
import { generate } from "controllers/variations";
import { TweetContext } from "context/tweetContext";
import { getAccount } from "utils/sessionHelper";
import { useOnClickOutside } from "utils/helpers";
import numbro from "numbro";
import { isAllowed, getPlan } from "../../controllers/subscription";
import { PreviewText } from "components/preview-text"
import { formatTweetFromPost } from "../../utils/linkedinUtils";
import { textStyle } from "theme/names";

let maxImpression = 0;
let maxEngagement = 0;
let maxEngagementPercent = 0;
let maxLikes = 0;
let maxReplies = 0;
let maxShares = 0;

export function TeamPerformance({ stats = [], isLoading = false }) {

  const data = useMemo(
    () => {
      return stats
    },
    [stats]
  );

  //console.log(data);
  // console.log("maxImpression: " + maxImpression);

  const columns = useMemo(
    () => [
      {
        Header: "",
        accessor: "image",
        tooltipText: "Profile Pic",
        sortDescFirst: true,
        Cell: ({ value }) => (
          <Box>
            <Image rounded="full" src={value} w="10" h="10" />
          </Box>
        ),
      },
      {
        Header: "Name",
        accessor: "name",
        tooltipText: "Name",
        disableSortBy: true,
        Cell: ({ value }) => (
          <Text
            textStyle={textStyle["body.medium.light"]}
            w="30"
            fontSize="sm"
            textAlign="left"
          >
            {value}
          </Text>
        ),
      },
      {
        Header: "Views.",
        accessor: "impression",
        tooltipText: "Impressions",
        isNumeric: true,
        sortDescFirst: true,
        Cell: ({ value }) => (
          <Text
            textStyle={textStyle["body.medium.light"]}
            fontWeight={value && maxImpression == value ? "900" : "400"}
            textAlign="left"
          >
            {value ? numbro(value)?.format({ thousandSeparated: true }) : 0}
          </Text>
        ),
      },
      {
        Header: "Engag.",
        accessor: "engagement",
        tooltipText: "Engagement",
        isNumeric: true,
        sortDescFirst: true,
        Cell: ({ value }) => (
          <Text textStyle={textStyle["body.medium.light"]}
            fontWeight={value && maxEngagement == value ? "900" : "400"}
            textAlign="left"
          >
            {value ? numbro(value)?.format({ thousandSeparated: true }) : 0}
          </Text>
        ),
      },
      {
        Header: "Engag. %",
        accessor: "engagementPercent",
        tooltipText: "Engagement Percentage",
        sortDescFirst: true,
        Cell: ({ value }) => (
          <Text
            fontWeight={value && maxEngagementPercent == value ? "900" : "400"}
            textAlign="left"
          >
            {!value || value == Infinity ? 0 + "%" : value?.toFixed(2) + "%"}
          </Text>
        ),
      },
      {
        Header: "Likes",
        accessor: "likes",
        tooltipText: "Likes",
        isNumeric: true,
        sortDescFirst: true,
        Cell: ({ value }) => (
          <Text textStyle={textStyle["body.medium.light"]}
            fontWeight={value && maxLikes == value ? "900" : "400"}
            textAlign="left"
          >
            {value ? numbro(value)?.format({ thousandSeparated: true }) : 0}
          </Text>
        ),
      },
      {
        Header: "Replies",
        accessor: "replies",
        tooltipText: "Replies",
        isNumeric: "true",
        sortDescFirst: true,
        Cell: ({ value }) => (
          <Text textStyle={textStyle["body.medium.light"]}
            fontWeight={value && maxReplies == value ? "900" : "400"}
            textAlign="left"
          >
            {value ? numbro(value)?.format({ thousandSeparated: true }) : 0}
          </Text>
        ),
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy);

  return (
    <Box>
      <Heading fontSize="xl">Detailed Team performance</Heading>
      <Box
        mt="6"
        border="1px"
        borderColor={useColorModeValue("gray.100", "whiteAlpha.300")}
        borderRadius="xl"
        p="3"
        pb="0"
        // width="fit-content"
        maxWidth="100%"
        overflowX="scroll"
        position="relative"
        ml={{ base: "0", md: "6" }}
      >
        <Table {...getTableProps()} fontSize="xs">
          <Thead>
            {headerGroups.map((headerGroup) => (
              <Tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(
                      column.getSortByToggleProps({ title: undefined })
                    )}
                    paddingX="1"
                  >
                    <Tooltip label={column.tooltipText} key={index}>
                      <Box>
                        {column.render("Header")}
                        <chakra.span pl="1.5">
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <TriangleDownIcon aria-label="sorted descending" />
                            ) : (
                              <TriangleUpIcon aria-label="sorted ascending" />
                            )
                          ) : null}
                        </chakra.span>
                      </Box>
                    </Tooltip>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td
                      {...cell.getCellProps()}
                      paddingX="1"
                      textAlign="center"
                    >
                      {cell.render("Cell")}
                    </Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
        {!isLoading && stats.length <= 0 && (
          <Text textStyle={textStyle["body.medium.light"]} p="8" textAlign="center">
            No stats found for organization members
          </Text>
        )}
        {isLoading && (
          <Center pt={10} h="400px">
            <PuffLoader
              color={"#0A66C2"} 
              loading={isLoading}
              cssOverride={{display: "block", margin: "0 auto", borderColor: "red"}}
              size={50}
            />
          </Center>
        )}
      </Box>
    </Box>
  );
}

